<button
  class="history-infos-btn"
  tiime-button
  color="primary"
  icon
  small
  tiimeTooltip="Afficher l'historique"
  (click)="$event.stopPropagation(); openHistoryInfosOverlay()"
>
  <mat-icon class="history-infos-icon" fontSet="fontastic" fontIcon="icon-soon-24"></mat-icon>
</button>
<div class="overlay-anchor" #overlayAnchor></div>
